import React, { useState, useEffect, useCallback } from "react";
import {
  SearchMajor,
  SortAscendingMajor,
  SortDescendingMajor,
  SortMinor,
} from "@shopify/polaris-icons";
import moment from "moment";
import debounce from "lodash.debounce";
import callApi from "../../utils/apiCaller";
import { Row } from "reactstrap";
import parse from "html-react-parser";

import Swal from "sweetalert2";

import { Link as LinkRouter } from "react-router-dom";
import {
  Card,
  Badge,
  ResourceList,
  ResourceItem,
  Filters,
  ChoiceList,
  Pagination,
  Icon,
  TextStyle,
  Link,
} from "@shopify/polaris";

import config from "../../config/config";
import { useSelector } from "react-redux";

const currencyFormatter = require("currency-formatter");

const DisputeTable = (props) => {
  const listStore = useSelector((state) => state.listStore);
  const dataSettings = useSelector((state) => state.dataSettings);
  const [isLoading, setIsLoading] = useState(false);
  const [listOrders, setListOrders] = useState([]);
  const [listDispute, setlistDispute] = useState([]);
  const [optionStore, setOptionStore] = useState([]);
  const [totalDispute, setTotalDispute] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchRender, setSearchRender] = useState("");
  const [dateRange, setDateRange] = useState([props.timeSelected]);
  const [storeSelected, setStoreSelected] = useState([config.shop]);
  const [paymentSelected, setPaymentSelected] = useState(["paypal"]);
  const [sort, setSort] = useState({
    pattern: "create_time",
    direction: "desc",
  });
  const [perPage, setPerPage] = useState([props.type === "latest" ? 10 : 25]);
  const optionsPerPage = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "75", value: 75 },
    { label: "100", value: 100 },
  ];

  const [statusSelected, setStatusSelected] = useState(["all"]);
  const [reasonSelected, setReasonSelected] = useState(["all"]);
  const [stageSelected, setStageSelected] = useState(["all"]);
  const optionsStatus = [
    { label: "Open", value: "OPEN" },
    {
      label: "Waiting for buyer response",
      value: "WAITING_FOR_BUYER_RESPONSE",
    },
    {
      label: "Waiting for seller response",
      value: "WAITING_FOR_SELLER_RESPONSE",
    },
    { label: "Under review", value: "UNDER_REVIEW" },
    { label: "Resolved", value: "RESOLVED" },
    { label: "Other", value: "OTHER" },
    { label: "All", value: "all" },
  ];
  const optionsReason = [
    { label: "All", value: "all" },
    {
      label: "Not received",
      value: "MERCHANDISE_OR_SERVICE_NOT_RECEIVED",
    },
    {
      label: "Not as described",
      value: "MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED",
    },
    { label: "Unauthorised", value: "UNAUTHORISED" },
    { label: "Credit not processed", value: "CREDIT_NOT_PROCESSED" },
    { label: "Duplicate transaction", value: "DUPLICATE_TRANSACTION" },
    { label: "Incorrect amount", value: "INCORRECT_AMOUNT" },
    { label: "Pay by other means", value: "PAYMENT_BY_OTHER_MEANS" },
    {
      label: "Canceled recurring",
      value: "CANCELED_RECURRING_BILLING",
    },
    { label: "Problem with remittance", value: "PROBLEM_WITH_REMITTANCE" },
    { label: "Other", value: "OTHER" },
  ];

  const optionsLifeCycleStage = [
    {
      label: "Inquiry",
      value: "INQUIRY",
    },
    {
      label: "Chargeback",
      value: "CHARGEBACK",
    },
    { label: "Pre Arbitration", value: "PRE_ARBITRATION" },
    { label: "Arbitration", value: "ARBITRATION" },
    { label: "All", value: "all" },
  ];

  useEffect(() => {
    const getListDispute = (
      search,
      dateRange,
      status,
      reason,
      stage,
      page,
      recordPerPage
    ) => {
      setIsLoading(true);

      let params = {
        search,
        date_range: dateRange[0],
        status: status[0],
        reason: reason[0],
        stage: stage[0],
        page: page - 1,
        recordPerPage: recordPerPage[0],
        sort: sort,
        action: "getListDispute",
      };

      callApi("get", params).then((res) => {
        if (res.data.listDispute && res.data.listDispute.length) {
          res.data.listDispute.unshift({
            id: -1,
          });
        }

        setlistDispute(res.data.listDispute);
        setTotalDispute(parseInt(res.data.totalDispute));
        setIsLoading(false);
      });
    };
    getListDispute(
      search,
      dateRange,
      statusSelected,
      reasonSelected,
      stageSelected,
      currentPage,
      perPage
    );
  }, [
    search,
    dateRange,
    currentPage,
    perPage,
    statusSelected,
    reasonSelected,
    stageSelected,
    sort,
  ]);

  const emptyStateMarkup = (
    <div className="resource-list-empty">
      <div className="resource-list-empty__icon">
        <Icon color="sky" source={SearchMajor} />
      </div>
      <div className="resour-list-empty__text">
        <TextStyle variation="subdued">No disputes</TextStyle>
      </div>
    </div>
  );

  // const handleStoreTagRemove = (value) => {
  //   if (storeSelected.length > 1) {
  //     let newListStore = [...storeSelected];
  //     newListStore.splice(value, 1);
  //     setStoreSelected(newListStore);
  //   }
  // };

  const resourceName = {
    singular: "order",
    plural: "orders",
  };

  const updateSort = (pattern) => {
    setSort((old) => ({
      pattern,
      direction:
        // eslint-disable-next-line no-nested-ternary
        old.pattern === pattern
          ? old.direction === "asc"
            ? "desc"
            : "asc"
          : "asc",
    }));
  };

  const filters = [
    {
      key: "status",
      label: "Status",
      filter: (
        <ChoiceList
          title="Status"
          titleHidden
          choices={optionsStatus}
          selected={statusSelected}
          onChange={(value) => setStatusSelected(value)}
        />
      ),
      shortcut: true,
    },
    {
      // onRemove: handleTaggedWithRemove,
      key: "reason",
      label: "Reason",
      filter: (
        <ChoiceList
          title="Reason"
          titleHidden
          choices={optionsReason}
          selected={reasonSelected}
          onChange={(value) => setReasonSelected(value)}
        />
      ),
      shortcut: true,
    },
    {
      // onRemove: handleTaggedWithRemove,
      key: "stage",
      label: "Life cycle stage",
      filter: (
        <ChoiceList
          title="Life cycle stage"
          titleHidden
          choices={optionsLifeCycleStage}
          selected={stageSelected}
          onChange={(value) => setStageSelected(value)}
        />
      ),
      shortcut: true,
    },
    {
      key: "perPage",
      label: "Per page",
      filter: (
        <ChoiceList
          title="Per page"
          titleHidden
          choices={optionsPerPage}
          selected={perPage}
          onChange={(value) => setPerPage(value)}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = () => {
    const result = [];
    if (!isEmpty(statusSelected))
      result.push({
        onRemove: () => setStatusSelected(["all"]),
        key: "status",
        label:
          "Status: " +
          optionsStatus.find((option) => option.value == statusSelected).label,
      });
    if (!isEmpty(reasonSelected))
      result.push({
        onRemove: () => setReasonSelected(["all"]),
        key: "reason",
        label:
          "Reason: " +
          optionsReason.find((option) => option.value == reasonSelected).label,
      });
    if (!isEmpty(stageSelected))
      result.push({
        onRemove: () => setStageSelected(["all"]),
        key: "stage",
        label:
          "Life cycle stage: " +
          optionsLifeCycleStage.find((option) => option.value == stageSelected)
            .label,
      });

    return result;
  };

  const debounceSetSearch = useCallback(
    debounce((callback, param) => callback(param), 400),
    []
  );

  const filterControl = (
    <Filters
      appliedFilters={appliedFilters()}
      queryValue={searchRender}
      filters={filters}
      onQueryChange={(value) => {
        const phoneRegEx = new RegExp("^[a-zA-Z0-9_.#.-]*$");
        if (!phoneRegEx.test(value)) {
          Swal.fire({
            icon: "warning",
            title: "Notice!",
            text: "Search content is not in the correct format",
            showCloseButton: true,
            showConfirmButton: false,
          });
        } else {
          setSearchRender(value);
          setCurrentPage(1);
          debounceSetSearch(setSearch, value);
        }
      }}
      onQueryClear={() => {
        setSearchRender(null);
        debounceSetSearch(setSearch, null);
      }}
      queryPlaceholder="Dispute Id/Transaction ID"
    ></Filters>
  );

  const processTransactionId = (transactionId) => {
    var res = transactionId.split(" ");
    let dataReturn = "";
    let paymentURL = "https://www.paypal.com/activity/payment/";
    for (let i = 0; i < res.length; i++) {
      if (res[i] === "") {
        dataReturn = "---";
      } else {
        if (i !== res.length - 1) {
          dataReturn +=
            '<a class="Polaris-Link" target="" href="' +
            paymentURL +
            res[i] +
            '">' +
            res[i] +
            "</a>" +
            "<br/>";
        } else {
          dataReturn +=
            '<a class="Polaris-Link" target="" href="' +
            paymentURL +
            res[i] +
            '">' +
            res[i] +
            "</a>";
        }
      }
    }
    return dataReturn;
  };

  const renderItem = (dispute, _, index) => {
    return (
      <ResourceItem id={dispute.id}>
        {dispute.id === -1 ? (
          <div className="d-flex" style={{ display: "contents" }}>
            <div className="vertical-center" style={{ width: "10%" }}>
              <p className="text-truncate font-weight-bold text-left">ID</p>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <p className="text-truncate font-weight-bold text-left d-flex">
                Transaction Id{" "}
              </p>
            </div>
            <div
              className="vertical-center"
              style={{ width: "15%" }}
              onClick={() => updateSort("reason")}
            >
              <p className="text-truncate font-weight-bold text-left  d-flex">
                Reason
                <Icon
                  source={
                    // eslint-disable-next-line no-nested-ternary
                    sort.pattern === "reason"
                      ? sort.direction === "asc"
                        ? SortAscendingMajor
                        : SortDescendingMajor
                      : SortMinor
                  }
                  color={sort.pattern === "reason" ? null : "skyLight"}
                />
              </p>
            </div>
            <div
              className="vertical-center"
              style={{ width: "15%" }}
              onClick={() => updateSort("status")}
            >
              <TextStyle variation="strong">
                <p className="text-truncate font-weight-bold text-center  d-flex">
                  Status
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "status"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={sort.pattern === "status" ? null : "skyLight"}
                  />
                </p>
              </TextStyle>
            </div>{" "}
            <div
              style={{ width: "10%" }}
              className="vertical-center"
              onClick={() => updateSort("dispute_life_cycle_stage")}
            >
              <TextStyle variation="strong">
                <p className="text-truncate font-weight-bold text-center  d-flex">
                  Life cycle stage
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "dispute_life_cycle_stage"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={
                      sort.pattern === "dispute_life_cycle_stage"
                        ? null
                        : "skyLight"
                    }
                  />
                </p>
              </TextStyle>
            </div>
            <div
              className="vertical-center"
              style={{ width: "5%" }}
              onClick={() => updateSort("dispute_amount")}
            >
              <TextStyle variation="strong">
                <p className="text-truncate font-weight-bold text-center  d-flex">
                  Amount
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "dispute_amount"
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={
                      sort.pattern === "dispute_amount" ? null : "skyLight"
                    }
                  />
                </p>
              </TextStyle>
            </div>
            <div
              className="vertical-center"
              style={{ width: "10%" }}
              onClick={() => updateSort("create_time")}
            >
              <TextStyle variation="strong">
                <p className="text-truncate font-weight-bold text-left  d-flex">
                  Create time
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "create_time "
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={sort.pattern === "create_time" ? null : "skyLight"}
                  />
                </p>
              </TextStyle>
            </div>
            <div
              className="vertical-center"
              style={{ width: "10%" }}
              onClick={() => updateSort("update_time")}
            >
              <TextStyle variation="strong">
                <p className="text-truncate font-weight-bold text-left  d-flex">
                  Update time
                  <Icon
                    source={
                      // eslint-disable-next-line no-nested-ternary
                      sort.pattern === "update_time  "
                        ? sort.direction === "asc"
                          ? SortAscendingMajor
                          : SortDescendingMajor
                        : SortMinor
                    }
                    color={sort.pattern === "update_time " ? null : "skyLight"}
                  />
                </p>
              </TextStyle>
            </div>
            <div
              style={{ width: "10%" }}
              className="vertical-center"
              onClick={() => updateSort("seller_response_due_date")}
            >
              <p className="text-truncate text-left font-weight-bold  d-flex">
                Due date
                <Icon
                  source={
                    // eslint-disable-next-line no-nested-ternary
                    sort.pattern === "seller_response_due_date"
                      ? sort.direction === "asc"
                        ? SortAscendingMajor
                        : SortDescendingMajor
                      : SortMinor
                  }
                  color={
                    sort.pattern === "seller_response_due_date"
                      ? null
                      : "skyLight"
                  }
                />
              </p>
            </div>
          </div>
        ) : (
          <div
            className="vertical-center d-flex"
            style={{ width: "100%", display: "contents" }}
          >
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">{dispute.dispute_id}</p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {parse(processTransactionId(dispute.transaction_id))}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "15%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {dispute.reason.replace("MERCHANDISE_OR_SERVICE_", "")}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "15%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  <Badge
                    status={
                      dispute.status == "RESOLVED"
                        ? "success"
                        : dispute.status == "WAITING_FOR_SELLER_RESPONSE"
                        ? "warning"
                        : "info"
                    }
                    progress={
                      dispute.status == "RESOLVED"
                        ? "complete"
                        : dispute.status == "UNDER_REVIEW"
                        ? "partiallyComplete"
                        : ""
                    }
                  >
                    {dispute.status}
                  </Badge>
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {dispute.dispute_life_cycle_stage}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "5%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {currencyFormatter.format(dispute.dispute_amount, {
                    code: dispute.dispute_currency_code,
                  })}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {moment(dispute.create_time).format("D MMM YYYY, hh:mm a")}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                <p className="text-truncate text-left">
                  {moment(dispute.update_time).format("D MMM YYYY, hh:mm a")}
                </p>
              </TextStyle>
            </div>
            <div className="vertical-center" style={{ width: "10%" }}>
              <TextStyle variation="strong">
                {dispute.seller_response_due_date !== "0000-00-00 00:00:00" ? (
                  <p className="text-truncate text-left">
                    {moment(dispute.seller_response_due_date).format(
                      "D MMM YYYY, hh:mm a"
                    )}
                  </p>
                ) : (
                  <p className="text-truncate text-left">---</p>
                )}
              </TextStyle>
            </div>
          </div>
        )}
      </ResourceItem>
    );
  };

  return (
    <Card>
      <div className="d-inline-block w-100">
        <ResourceList
          resourceName={resourceName}
          items={listDispute}
          renderItem={renderItem}
          loading={isLoading}
          filterControl={props.type === "latest" ? null : filterControl}
          emptyState={emptyStateMarkup}
        />
        <div className="d-flex justify-content-center p-4">
          <Pagination
            label={
              totalDispute
                ? `Showing ${(currentPage - 1) * perPage + 1} to ${Math.min(
                    currentPage * perPage,
                    totalDispute
                  )} of ${totalDispute} shipments`
                : null
            }
            hasPrevious={currentPage > 1}
            onPrevious={() => {
              setCurrentPage((value) => value - 1);
            }}
            hasNext={currentPage < Math.ceil(totalDispute / perPage)}
            onNext={() => {
              setCurrentPage((value) => value + 1);
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default DisputeTable;

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === "" || value == null;
  }
}
